import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, notification } from "antd";
import { withRouter } from "@/helpers/router";
import { getPriorArtByPatent } from "@/services/api-pqai";
import { isEmpty } from "lodash";

const formatUcid = pubId => {
  const match = pubId.match(/^(US)(\d+)(.*)/);
  return match ? `${match[1]}-${match[2]}-${match[3]}` : undefined;
};

const PriorArtLink = ({ value, router }) => {
  const [loading, setLoading] = useState(false);

  const onSearch = () => {
    setLoading(true);
    getPriorArtByPatent(value, 50)
      .then(results => {
        const ucids = results.map(result => formatUcid(result.publication_id)).filter(x => !isEmpty(x));
        router.push({
          pathname: "/patents/search",
          query: { ucid_spif: ucids.join("\n") }
        });
        setLoading(false);
      })
      .catch(() => {
        notification.error({
          message: "Oops. Something went wrong. Please try again later.",
          description: "Please contact support if the issue persists.",
          duration: 0,
          key: "find-prior-art-by-patent"
        });
        setLoading(false);
      });
  };

  return (
    <Button onClick={onSearch} loading={loading} type={"primary"} style={{ marginLeft: 5 }}>
      {"Find Prior Art"}
    </Button>
  );
};

PriorArtLink.propTypes = {
  value: PropTypes.string,
  router: PropTypes.object
};

export default withRouter(PriorArtLink);
